import { Box, Button, Card, TextField, makeStyles } from '@material-ui/core'
import { FlexHorizontal, Spacer } from '@vestaboard/installables'
import React, { useCallback, useState } from 'react'

import { Alert } from '@material-ui/lab'

export interface ITemplateCategory {
  title: string
}

export interface ITemplateCategoryForm {
  templateCategory?: ITemplateCategory | null
  onCreate?: (templateCategory: ITemplateCategory) => void
  onUpdate?: (templateCategory: ITemplateCategory) => void
  onDelete?: () => void
}

const useStyles = makeStyles({
  cardInner: {
    padding: 24
  }
})

export const TemplateCategoryForm = (props: ITemplateCategoryForm) => {
  const [title, setTitle] = useState<string>(props?.templateCategory?.title || '')
  const [error, setError] = useState<string | null>(null)
  const classes = useStyles()

  const onSave = useCallback(async () => {
    setError(null)

    if (!title) {
      setError('title')
      return
    }

    const save = props.onCreate || props.onUpdate

    if (save) {
      await save({
        title
      })
    }
  }, [props.onCreate, props.onUpdate, title])

  return (
    <>
      <Card>
        <Box className={classes.cardInner}>
          <TextField
            value={title}
            onChange={e => {
              setTitle(e.target.value)
            }}
            variant='outlined'
            label='Title'
            fullWidth
            error={error === 'title' && !title}
          />
          {error === 'title' && !title ? (
            <>
              <Spacer size='small' />
              <Alert severity='error'>Title is required</Alert>{' '}
            </>
          ) : null}
          <Spacer size='large' />
          <FlexHorizontal spaceBetween>
            <div />
            <FlexHorizontal>
              {props.onDelete ? (
                <Button
                  style={{
                    marginRight: 8
                  }}
                  size='large'
                  color='secondary'
                  variant='contained'
                  onClick={() => {
                    props?.onDelete?.()
                  }}>
                  Delete
                </Button>
              ) : null}
              {props.onUpdate ? (
                <Button size='large' color='primary' variant='contained' onClick={onSave}>
                  Update
                </Button>
              ) : null}
              {props.onCreate ? (
                <Button size='large' color='primary' variant='contained' onClick={onSave}>
                  Create
                </Button>
              ) : null}
            </FlexHorizontal>
          </FlexHorizontal>
        </Box>
      </Card>
    </>
  )
}
